import { DigitalMemberTag } from "common/components";
import { useElementIsLoaded } from "common/utilities";
import { useTranslate } from "common/utilities/useTranslate";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";
import EventsImage from "domains/landing/create/EventsImage.png";
import {
  SlidingContainer,
  StyledImage,
  StyledInfoContainer,
  StyledSectionContainer,
} from "domains/landing/create/shared";

export const EventsSection = () => {
  const { elementRef, isLoaded } = useElementIsLoaded(0.5);
  const translate = useTranslate();

  return (
    <StyledSectionContainer ref={elementRef}>
      <StyledInfoContainer>
        <div ref={elementRef}>
          <SlidingContainer $isLeft $isLoaded={isLoaded}>
            <DigitalMemberTag trackPage="Landing" />
            <StyledLandingTitle>{translate("app.discover.topic.tabs.events.title")}</StyledLandingTitle>
            <StyledLandingText>{translate("app.events.promo_text")}</StyledLandingText>
          </SlidingContainer>
        </div>
      </StyledInfoContainer>
      <StyledInfoContainer>
        <SlidingContainer $isLoaded={isLoaded}>
          <StyledImage src={EventsImage} alt={translate("app.discover.topic.tabs.events.title")} />
        </SlidingContainer>
      </StyledInfoContainer>
    </StyledSectionContainer>
  );
};
